import useResizeObserver from '@react-hook/resize-observer';
import { useRef, useState, useCallback } from 'react';
import { useDebounceValue } from './useDebounceValue';

export function useWidthObserver(initialWidth: number = 150, debounceMs: number = 50) {
  const panelRef = useRef<HTMLDivElement>();
  const [stateWidth, setStateWidth] = useState(initialWidth);
  const debouncedWidth = useDebounceValue(stateWidth, debounceMs);
  const resizeFn = useCallback(
    () => setStateWidth(panelRef?.current?.clientWidth ?? initialWidth),
    []
  );
  useResizeObserver(panelRef, resizeFn);
  const width = debouncedWidth === initialWidth ? stateWidth : debouncedWidth;
  return { width, panelRef };
}
